import { Action } from './types'

export const setJobId = (jobId: string): Action => ({
  type: 'SET_JOB_ID',
  payload: jobId
})

export const clearJobId = (): Action => ({
  type: 'CLEAR_JOB_ID'
})

export const updateOpenInputSets = (items: number[]): Action => ({
  type: 'UPDATE_OPEN_INPUT_SETS',
  payload: items
})

export const openNextInputSet = (name: string): Action => ({
  type: 'OPEN_NEXT_INPUT_SET',
  payload: name
})



// WEBPACK FOOTER //
// ./src/actions/calculation.ts